import React, { useEffect } from "react"
import styled from "styled-components"

const Styled = {
    Wrap:styled.div`
        width:90px;
        height:35px;
        background-color:gold;
        border-radius: 10px;
        display:flex;
        justify-content: center;
        flex-direction:row;
        align-items: center;
        :hover{
            opacity:50%;
            cursor:pointer;
        }
    `,
    Fonts:styled.p`
        font-size:20px;
        font-weight: 500;
        font-family:"Jua", sans-serif;
    `,
}

interface PropsType {
    content:string; //text
    Event?:number; //몇번째 문제인지
    PageNumber?:any; //몇페이지 넘어갈래
    Page?:any; //현재페이지 (Solo 에서는 boolean )
    setPage?:any; //Page의 함수
    Point?:number; //지금 선택지의 점수
    Points?:any; //여태 나온 점수
    setPoints?:any; //점수 더하기
    babies?:number;
    setBabies?:any;
    FamilyNum?:number;
}
const BtnCompo =(props:PropsType)=>{
    const Content = props.content;
    const Event = props.content;
    const PageNumber = props.PageNumber
    const Page = props.Page;
    const setPage = props.setPage;
    const Point = props.Point;
    const Points = props.Points;
    const setPoints = props.setPoints;
    const FamilyNum = props.FamilyNum
    const babies = props.babies;
    const setBabies = props.setBabies;

    const EventFunction =()=>{
        setPoints(Point + Points); //포인트 더하기
        setPage(PageNumber);
        if(babies === undefined){
            //
        }else{
            setBabies(FamilyNum)
        }
    }
    
        return(
            <Styled.Wrap onClick={EventFunction}>
                <Styled.Fonts>{Content}</Styled.Fonts>
            </Styled.Wrap>
        )
}
export default BtnCompo